import React from 'react';
import styled from 'styled-components';

const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  li {
    padding: 18px 10px;
  }
  a{
      display: flex;
      align-items: flex-start;
  }
  img {
     width:10%; 
  }
  span{
    display: flex;
    align-items:center;
    margin-left:8px;
    width: 100%;
    margin-bottom: 29px;
    margin-top: 8px;
  }
  @media (max-width: 768px) {
    flex-flow: column nowrap;
    background-color: #040714;
    position: fixed;
    transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
    top: 0;
    right: 0;
    height: 100vh;
    width: 414px;
    padding-left: 9rem;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;
    li {
      color: #fff;
    }
  }
`;

const RightNav = ({ open }) => {
  return (
    <Ul open={open}>
       <a href="/home">
                  <img src="/images/home-icon.svg" alt="HOME" />
                  <span>HOME</span>
                </a>
                <a>
                  <img src="/images/search-icon.svg" alt="SEARCH" />
                  <span>SEARCH</span>
                </a>
                <a>
                  <img src="/images/watchlist-icon.svg" alt="WATCHLIST" />
                  <span>WATCHLIST</span>
                </a>
                <a>
                  <img src="/images/original-icon.svg" alt="ORIGINALS" />
                  <span>ORIGINALS</span>
                </a>
                <a>
                  <img src="/images/movie-icon.svg" alt="MOVIES" />
                  <span>MOVIES</span>
                </a>
                <a>
                  <img src="/images/series-icon.svg" alt="SERIES" />
                  <span>SERIES</span>
                </a>
              
              
    </Ul>
  )
}


export default RightNav